import PrepareOrder from '@/pages/PrepareOrder'

export default {
    path: '',
    component: PrepareOrder,
    children: [
        {
            path: '/prepare/order/:ref',
            name: 'Prepare Order',
            component: PrepareOrder,
        }
    ]
}


// WEBPACK FOOTER //
// ./src/router/prepareorder.js